import MinimalLayout from "../layout/MinimalLayout";
import LoginPage from "../pages/Auth/LoginPage";
import ResetPasswordPage from "../pages/Auth/ResetPasswordPage";
import ForgotPasswordPage from "../pages/Auth/ForgotPasswordPage";

const LoginRoutes={
    path:'/',
    element:<MinimalLayout/>,
    children:[
        {path:'/login',element:<LoginPage/>},
        {path:'/forgot-password',element:<ForgotPasswordPage/>},
        {path:'/reset-password',element:<ResetPasswordPage/>},
      ]

}

export default LoginRoutes